import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-links">
                    <Link to="/privacy">Polityka prywatności</Link>
                    <Link to="/terms">Regulamin</Link>
                    <Link to="/contact">Kontakt</Link>
                </div>
                <p>© {new Date().getFullYear()} PickOneGift. Wszystkie prawa zastrzeżone.</p>
            </div>
        </footer>
    );
}
